import { render, staticRenderFns } from "./EstructuraComercialPantalla.vue?vue&type=template&id=42db7452&"
import script from "./EstructuraComercialPantalla.vue?vue&type=script&lang=ts&"
export * from "./EstructuraComercialPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports